<template id="" >
  <div class="training">
    <div class="md-layout">
      <md-card class="md-layout-item md-size-45 md-medium-size-100">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>save_alt</md-icon></div>
          <h4 class="title">Training Materials: Reading</h4>
        </md-card-header>
        <md-card-content class="training-content">
          <h3>SafeCore Safety & Risk Management Orientation</h3>
          <p>The course is designed as an overview of the advantages and limitations of GPR, SafeCore Systems Patent Pending marking system and the SafeCore interior locate color code identifiers. <br/><br/>
          Please complete the SafeCore Safety Orientation test upon the completion of this overview.  Licensed members are required to complete the course within 30 days of sign in. </p>

        </md-card-content>
        <md-card-actions>
          <md-button class="md-info" @click="openContent">Download Content</md-button>
        </md-card-actions>
      </md-card>
      <md-card class="md-layout-item md-size-45 md-medium-size-100">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>school</md-icon></div>
          <h4 class="title">Certification Quiz: IBGW</h4>
        </md-card-header>
        <md-card-content class="certification-content">
          <h3>SafeCore Safety and Risk Management Test</h3>
          <p>Please complete the SafeCore Safety Orientation test upon the completion of this overview.  Licensed members are required to complete the course within 30 days of sign in.</p>
        </md-card-content>
        <md-card-actions>
          <router-link :to="{ name: 'Training Test'}">
            <md-button class="md-info">Take Test</md-button>
          </router-link>
        </md-card-actions>
      </md-card>
    </div>
  </div>


</template>
<script>
  export default {
    data(){
      return{

      }
    },
    methods: {
      openContent(){
        window.open("https://safecorefiles.blob.core.windows.net/downloadfiles/IBGW.SafeCore Precertification 7.22.20.pdf", '_blank')
      }
    }
  }

</script>
<style lang="scss">
</style>
